// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3y0J4","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3MJ5S","obliqueLine":"membershipbadge_obliqueLine__KquYp"};